export type ShowOption = 'all' | 'searched' | 'created';
export type DateRangeOption = 'all' | 'thisMonth' | 'thisQuarter' | 'thisYear' | 'custom';
export type LeakVisibilityOption = 'all' | 'visible' | 'notVisible';

export interface MapFilterState {
    show: ShowOption;
    dateRange: DateRangeOption;
    /** ISO YYYY-MM-DD strings, or null when not set. Only used when dateRange === 'custom'. */
    customDateRange: {
        from: string | null;
        to: string | null;
    };
    leakVisibility: LeakVisibilityOption;
    /** When true, restrict to POIs flagged as a no-dig repair (nodig_fix). Independent of status. */
    noDigRepairs: boolean;
    leakTypes: {
        leakFound: boolean;
        noLeakFound: boolean;
        inconclusive: boolean;
        awaitingAssessment: boolean;
        alreadyMarkedUp: boolean;
        unableToCheck: boolean;
    };
    pipeTypes: {
        main: boolean;
        communication: boolean;
        customerSupplyLine: boolean;
        stopTapBoundaryBox: boolean;
        fitting: boolean;
        unknown: boolean;
    };
}

export const DEFAULT_MAP_FILTER_STATE: MapFilterState = {
    show: 'all',
    dateRange: 'all',
    customDateRange: { from: null, to: null },
    leakVisibility: 'all',
    noDigRepairs: false,
    leakTypes: {
        leakFound: true,
        noLeakFound: true,
        inconclusive: true,
        awaitingAssessment: true,
        alreadyMarkedUp: true,
        unableToCheck: true,
    },
    pipeTypes: {
        main: true,
        communication: true,
        customerSupplyLine: true,
        stopTapBoundaryBox: true,
        fitting: true,
        unknown: true,
    },
};

export const SHOW_OPTIONS: Array<{ value: ShowOption; label: string }> = [
    { value: 'all', label: 'All' },
    { value: 'searched', label: 'Searched' },
    { value: 'created', label: 'Created' },
];

export const DATE_RANGE_OPTIONS: Array<{ value: DateRangeOption; label: string }> = [
    { value: 'all', label: 'All' },
    { value: 'thisMonth', label: 'This Month' },
    { value: 'thisQuarter', label: 'This Quarter' },
    { value: 'thisYear', label: 'This Year' },
    { value: 'custom', label: 'Custom' },
];

export const LEAK_VISIBILITY_OPTIONS: Array<{ value: LeakVisibilityOption; label: string }> = [
    { value: 'all', label: 'All' },
    { value: 'visible', label: 'Visible' },
    { value: 'notVisible', label: 'Not Visible' },
];
